import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { bindFailClosedCommerceState, markAppOpened, track, webAdapter } from './lib/platform.js';
import './styles/tokens.css';
import './styles/app.css';

document.documentElement.dataset.channel = 'web';
bindFailClosedCommerceState(webAdapter);
const savedTheme = localStorage.getItem('petrhythm.theme');
if (savedTheme && savedTheme !== 'system') document.documentElement.dataset.theme = savedTheme;
if (import.meta.env.PROD && 'serviceWorker' in navigator) window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '');
// sendBeacon을 쓰지 않는다. 자격 증명을 포함해 보내기 때문에 preflight가
// Access-Control-Allow-Credentials를 요구하고, 그것이 없어 브라우저가 전송을 전부 막았다
// (실측 2026-08-11: 첫 방문 계측 1건 전송 실패). 계측에 쿠키를 실을 이유도 없다.
// keepalive는 페이지를 떠나도 전송이 끝나게 한다.
if (apiBase) window.addEventListener('petrhythm:analytics', ((event: CustomEvent) => {
  void fetch(`${apiBase}/v1/analytics`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(event.detail),
    credentials: 'omit',
    keepalive: true,
  }).catch(() => undefined);
}) as EventListener);

// 진입 즉시 1회. 이전에는 /app 안에서 아이가 등록된 뒤에만 나갔다 —
// 랜딩만 보고 떠난 사람도, 아이를 아직 등록하지 않은 사람도 세지 않았으므로
// 활성화 퍼널에 분모가 없었다. 첫 방문 시각도 여기서 찍어야 첫 기록까지의 시간이
// 실제 도착 시점부터 재진다.
markAppOpened();
track('app_opened');

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
